import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as constants from './types';
import * as api from './api';

export const sortTestCases = createAction(constants.SORT_TEST_CASES);
export const setTestCaseQueryType = createAction(constants.SET_TEST_CASE_QUERY);
export const handleChangePagination = createAction(constants.CHANGE_PAGINATION);
export const cleanupTestList = createAction(constants.CLEANUP_TEST_LIST);

export const getTestCases = createApiAction(
  constants.GET_TEST_CASES,
  (params) => api.getTestCases(params),
  { meta: { skipErrorPage: true } },
);
